import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

export const customSettingsQuerySchema = z.object({
  id: z.number(),
  name: z.string(),
  value: z.string(),
  user_id: z.number(),
});

export type CustomSettingsQuerySchema = z.infer<typeof customSettingsQuerySchema>;

export const customSettingsResponseSchema = paginatedResponseSchema(customSettingsQuerySchema);
export type CustomSettingsResponseSchema = z.infer<typeof customSettingsResponseSchema>;
